<ng-container *ngIf="installation" >
    <div>
        <mat-tab-group mat-align-tabs="center">
            <mat-tab label="Evolution mensuelle"> <app-installation-monthly-evolution [installation]="installation" ></app-installation-monthly-evolution>  </mat-tab>
            <mat-tab label="Répartition horaire"> <app-installation-hourly-distribution [installation]="installation" ></app-installation-hourly-distribution>  </mat-tab>
            <mat-tab label="Répartition hebdomadaire"> <app-installation-weekly-distribution [installation]="installation" ></app-installation-weekly-distribution>  </mat-tab>
            <!-- <mat-tab label="Moyens de paiement"> <app-installation-payment-method  ></app-installation-payment-method>  </mat-tab> -->
            <!-- Moyen de paiement : à voir si utlisé -->
         </mat-tab-group>
    </div>


</ng-container>